import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6cfd60cd&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "@/assets/accounts.css?vue&type=style&index=0&id=6cfd60cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd60cd",
  null
  
)

export default component.exports